import React, { useEffect, useState } from 'react';
import { clearAuthReturnPath, getAuthReturnPath, handleAuthCallback } from '../services/auth';

const AuthCallback = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const finalize = async () => {
      try {
        await handleAuthCallback();
        const returnPath = getAuthReturnPath();
        clearAuthReturnPath();
        window.location.replace(returnPath || '/map');
      } catch (err) {
        if (isMounted) {
          setError(err.message || 'Auth failed');
        }
      }
    };

    finalize();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h2>Signing you in…</h2>
      {error && <p style={{ color: '#ff6b6b' }}>{error}</p>}
    </div>
  );
};

export default AuthCallback;
